import { CommonKeys } from "../../../common/enums";
import { FormularInputType } from "../FormularGroupInputs";
import type { StammElement } from "./StammElement";

export const STAMM_META_TYPE = "AM_Services.Domain.Models.Formulare.StammElementMeta, AM_Services.Domain.Standard";

export const FormularGroupStammStammElementMetaSchema = {
    $id: "FormularGroupStammStammElementMetaSchema",
    title: "FormularGroupStammStammElementMeta Schema",
    type: "object",
    allOf: [
        { $ref: "FormularGroupStammStammElementBaseSchema" },
        {
            type: "object",
            properties: {
                [CommonKeys.Type]: { const: STAMM_META_TYPE },
                Typ: { type: "number", nullable: true },
                ManualInputType: { type: "number", nullable: true }
            }
        }
    ],
};

export interface StammElementMeta extends StammElement {
    Typ: StammElementMetaTyp
    ManualInputType: FormularInputType
}

enum StammElementMetaTyp {
    Manuell, Techniker, AuftragNr,
    AnlageNrIntern, AnlageNrExtern,
    WartungsTurnus, WartungsMonat, WartungsMonatName, AnzahlWartungenJahr,
}